import React from 'react';
import BreakdownRingChart from '../../../../../../shared/designSystem/components/BreakdownRingChart';

// BasketItemRingChart — thin adapter for the shared BreakdownRingChart.
//
// Surfaces two dimensions: Quantity and Total. BreakdownRingChart reads
// `item[dimension]` directly so `quantity` and `total` map cleanly without
// a normalization step. The default DIMENSION_LABELS map already covers
// these names via startCase fallback.
const BasketItemRingChart = ({ data, height, selectedBasketItemDimension = 'total' }) => (
  <BreakdownRingChart
    data={data}
    dimension={selectedBasketItemDimension}
    height={height}
    dimensionLabels={{
      quantity: 'Quantity',
      total: 'Total',
    }}
  />
);

export default BasketItemRingChart;
